import { render } from "./CheckScale.vue?vue&type=template&id=09206f60&scoped=true"
import script from "./CheckScale.vue?vue&type=script&lang=js"
export * from "./CheckScale.vue?vue&type=script&lang=js"

import "./CheckScale.vue?vue&type=style&index=0&id=09206f60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09206f60"]])

export default __exports__